import request from '@/utils/request'
import store from '../store'

// 获取展厅列表数据
export function getExhibitionList (data) {
  return request({
    url: '/ordering_system_mobile/mallitem/getExhibitionList',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      ...data
    }
  })
}

// 获取展厅页 - 商品列表
export function getExhibitionMallList (data) {
  return request({
    url: '/ordering_system_mobile/mallitem/getExhibitionMallList',
    method: 'post',
    data: {
      num: 10,
      ...data
    }
  })
}

// 展厅页品牌名称
export function getBrandNameList (data) {
  return request({
    url: '/ordering_system_mobile/mallitem/getBrandNameList',
    method: 'post',
    data: {
      ...data
    }
  })
}

// 展厅页类目名称
export function getCategoryNameList (data) {
  return request({
    url: '/ordering_system_mobile/mallitem/getCategoryNameList',
    method: 'post',
    data: {
      ...data
    }
  })
}

// 商品详情
export function getExhibitionMallDetails (data) {
  return request({
    url: '/ordering_system_mobile/mallitem/getExhibitionMallDetails',
    method: 'post',
    data: {
      ...data
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/goods.js